import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { PageSubTitle } from 'components/common/Elements/Elements';
import TextWidget2 from 'components/common/charts/TextWidget2/TextWidget2';
import Chart from './Chart/Chart';
import TicketsStatus from './TicketsStatus/TicketsStatus';

import { chartColor } from '../../helpers/configurates';

import classes from './Widgets.module.scss';

const Widgets = ({ customerId, data }) => {
  const widget = {
    title: 'First Response (Minutes)',
    value: data.avgRespTime
  };

  return (
    <section className={classes.charts}>
      <PageSubTitle hiden title="Tickets chart and widgets" size={3} />
      <div className={classes.widgets}>
        <TicketsStatus data={data.ticketsStatus} chartColor={chartColor} />
        <TextWidget2
          data={widget}
          tooltip={'Avg minutes between ticket creation and First Response'}
          className={classes.respons}
        />
      </div>
      <Chart customerId={customerId} chartColor={chartColor} />
    </section>
  );
};

Widgets.propTypes = {
  customerId: PropTypes.string,
  data: PropTypes.object
};

export default memo(Widgets);
